import { render, staticRenderFns } from "./CallRecords.vue?vue&type=template&id=abf5022e"
import script from "./CallRecords.vue?vue&type=script&lang=js"
export * from "./CallRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports